import React, { Component } from "react";
import Modal from "react-modal";

// Help consent gate (digadop-ai/lou#11). A non-dismissable modal shown after
// login when Lou reports the user/org has not accepted a required agreement.
// digadop-help is org-mode: this app (qa-client) is the Help ADMIN app, so the
// authenticated user is the org admin and a single acceptance covers the tenant.
// The backend (dbServer #134) proxies Lou, which owns the policy + the ledger.
//
// Props:
//   agreements: [{ agreementId, version, title, documentUrl, mode }]
//   accepting:  bool   -- a POST /consent/accept is in flight
//   error:      string -- last accept error, if any
//   onAccept:   () => void -- record acceptance of every listed agreement

Modal.setAppElement("body");

// Opaque overlay: fully hide (not just dim) the app behind the gate so no
// content is usable until the required terms are accepted.
const overlayStyle = {
  backgroundColor: "rgba(20, 28, 38, 0.97)",
  zIndex: 10000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const contentStyle = {
  position: "static",
  inset: "auto",
  width: "90%",
  maxWidth: "520px",
  maxHeight: "85vh",
  overflowY: "auto",
  border: "none",
  borderRadius: "8px",
  padding: "0px",
};

export default class ConsentGate extends Component {
  render() {
    const { agreements, accepting, error, onAccept } = this.props;
    const list = agreements || [];
    const multiple = list.length > 1;
    return (
      <Modal
        isOpen={true}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        style={{ overlay: overlayStyle, content: contentStyle }}
        contentLabel="Terms acceptance required"
      >
        <div className="modal-content">
          <div className="modal-header p-4" style={{ borderBottom: "none" }}>
            <h3 className="modal-title">Before you continue</h3>
          </div>
          <div className="modal-body px-4">
            <p>
              To use Digadop Help, please review and accept the following
              {multiple ? " agreements" : " agreement"}:
            </p>
            <ul style={{ paddingLeft: "1.1rem" }}>
              {list.map((a) => (
                <li key={a.agreementId + "@" + a.version} className="mb-2">
                  <a
                    href={a.documentUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {a.title || a.agreementId}
                  </a>
                  {a.version ? (
                    <span className="text-muted"> (v{a.version})</span>
                  ) : null}
                </li>
              ))}
            </ul>
            <p className="text-muted" style={{ fontSize: "0.85rem" }}>
              By selecting "I Agree" you confirm that you have read and accept
              {multiple ? " these agreements" : " this agreement"} on behalf of
              your organization.
            </p>
            {error ? (
              <div className="alert alert-danger py-2" role="alert">
                {error}
              </div>
            ) : null}
          </div>
          <div
            className="modal-footer p-3"
            style={{ borderTop: "none", justifyContent: "flex-end" }}
          >
            <button
              type="button"
              className="btn btn-primary"
              disabled={accepting || list.length === 0}
              onClick={onAccept}
            >
              {accepting ? "Saving..." : "I Agree"}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}
